import { MultiSelect, Option } from "react-multi-select-component";
import { h } from "preact";
import { useText } from "preact-i18n";
import { FilterItemProps } from "components/Filters/Filters";
import { useEffect } from "preact/hooks";
import FilterWithLabel from "components/Filters/FilterWithLabel/FilterWIthLabel";

export interface FilterOption {
    value: string | number;
    label?: string;
    labelId?: string;
}

interface FiltersProps extends FilterItemProps<Option[]> {
    options: FilterOption[];
    defaultSelectAll?: boolean;
}

const FilterMultiSelect = (props: FiltersProps) => {
    const {
        addressId,
        fieldName,
        options,
        value,
        onChange,
        defaultSelectAll = false,
    } = props;

    const selectTranslations = useText({
        allItemsAreSelected: "general.labels.allTypes",
        clearSearch: "general.labels.clearSearch",
        clearSelected: "general.labels.clearSelected",
        noOptions: "general.labels.noOptions",
        search: "general.labels.search",
        selectAll: "general.labels.selectAll",
        selectAllFiltered: "general.labels.selectAllFiltered",
        selectSomeItems: "general.labels.selectSomeItems",
        create: "general.labels.create",
    });

    const labels = useText(
        Object.fromEntries(
            options.flatMap((option, index) =>
                option.labelId !== undefined
                    ? [[String(index), option.labelId]]
                    : [],
            ),
        ),
    );
    const translatedOptions: Option[] = options.map((option, index) => ({
        ...option,
        label:
            option.labelId !== undefined
                ? (labels[String(index)] ?? "Missing")
                : (option.label ?? ""),
    }));

    useEffect(() => {
        if (!value && defaultSelectAll) {
            onChange?.(translatedOptions);
        }
    }, []);

    return (
        <FilterWithLabel {...props}>
            <MultiSelect
                options={translatedOptions}
                value={value ?? (defaultSelectAll ? translatedOptions : [])}
                overrideStrings={selectTranslations}
                hasSelectAll={false}
                disableSearch
                onChange={onChange}
                labelledBy={`MultiSelect-${fieldName}-${addressId}`}
            />
        </FilterWithLabel>
    );
};

export default FilterMultiSelect;
